export class ColorModel {
    color_index: number
    color_name: string

    constructor(
        color_index: number,
        color_name: string
    ) {
        this.color_index = color_index
        this.color_name = color_name
    }
}